var React = require('react');

function Lv (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#a2001d","d":"M0 0h512v189.2l-38.5 70 38.5 63.6V512H0V322.8l39.4-63L0 189.1z","key":0}),React.createElement("path",{"fill":"#eee","d":"M0 189.2h512v133.6H0z","key":1})])]);
}

Lv.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Lv;

Lv.default = Lv;
